export default __webpack_public_path__ + "static/diag-check-11d5e51a2db356e50420587a8a011c6d.webp";